<template>
    <div>
        <div v-if="$common.isClient_whole()" :style="{paddingTop: channel_name && !$common.isClient_hm() ? '0px' : '83px'}">
            <Wp_jd_home_simple @getColors="getColors"></Wp_jd_home_simple>
        </div>
        <div v-else>
            <Wp_home_all_model ref="Wp_home_all_model" top-px="100px" :parent="this.JdSelectListSheet_parent"></Wp_home_all_model>
        </div>
    </div>
</template>

<script>
    // import Vue from 'vue'
    // import JdCategoryTabs from "../custom/JdCategoryTabs";
    // import Wp_img_swipe from "../custom/Wp_img_swipe";
    // import Wp_image from "../custom/Wp_image";
    // import Wp_news from "../custom/Wp_news";
    // import Wp_jd_hot_sku_model from "../custom/Wp_jd_hot_sku_model";
    // import Wp_home_sortModels from "../custom/Wp_home_sortModels";
    // import Wp_grid from "../custom/Wp_grid";
    // import Wp_home_more_model from "../custom/Wp_home_more_model";
    //
    // import { Toast } from 'vant';
    //
    // Vue.use(Toast);

    import Wp_home_all_model from "../custom_model/Wp_home_all_model";
    import Wp_jd_home_simple from "./Wp_jd_home_simple";

    export default {
        name: "Wp_jd_home",
        components: {
            Wp_jd_home_simple,
            Wp_home_all_model,
            // Wp_home_more_model,
            // Wp_grid,
            // Wp_home_sortModels, Wp_jd_hot_sku_model, Wp_news, Wp_image, Wp_img_swipe, JdCategoryTabs,
            // 'Wp_home_banner_model': () => import('../custom/Wp_home_banner_model.vue'),
            // 'Wp_home_grid_model': () => import('../custom/Wp_home_grid_model.vue'),
            // 'Wp_home_news_model': () => import('../custom/Wp_home_news_model.vue'),
            // 'Wp_home_actives_model': () => import('../custom/Wp_home_actives_model.vue'),
            // 'Wp_home_hot_model': () => import('../custom/Wp_home_hot_model.vue'),
            // 'Wp_home_more_model': () => import('../custom/Wp_home_more_model.vue'),
            // 'Wp_home_grid_data_model': () => import('../custom/Wp_home_grid_data_model.vue'),

        },

        inject: ['JdSelectListSheet_parent'],

        // props:{
        //     isLoading:{type: Boolean, default: false}
        // },
        data() {
            return {
                channel_name: '',
            }
        },
        created(){
            this.channel_name = this.$common.getUrlKey("channel_name");

            // this.initComponentDatas();
            // this.initComponentDatasTest();

        },
        methods: {
            getColors(colors){
                this.JdSelectListSheet_parent.bg_color = colors.bg_color;
                this.JdSelectListSheet_parent.font_color = colors.font_color;
            },

            refreshHome(){
                if(this.$refs.Wp_home_all_model){
                    this.$refs.Wp_home_all_model.refreshHome();
                }
            },

            /**
             * 初始化推荐页的模板数据
             */
            initComponentDatas() {
                if(this.$refs.Wp_home_all_model) {
                    this.$refs.Wp_home_all_model.initComponentDatas();
                }
            },

        }
    }
</script>

<style scoped>

</style>